// extracted by mini-css-extract-plugin
module.exports = {"container":"_1y3sR2t","separator":"Dx8UHBf","pill":"_11DJhkg","viewMoreWrapper":"_20RIjVq","viewMore":"_22g1j7_"};